import { defineStore } from "pinia";
import axios_services from "@/axios-services";


export const useGroupsStore = defineStore("groups", {
  state: () => {
    return {
      groups: [],
    };
  },
  getters: {
    getGroups(state) {
      return state.groups;
    }
  },
  actions: {
    async fetchGroups() {
      await axios_services.get("oidc/groups").then((response) => {
        this.groups = response.data.groups.filter(group => group.name !== "geoville_admins" && !group.name.includes("organization_"));
      });
      console.log(this.groups);
    }
  },
});
